interface Props {
  value: string;
  onChange: (v: string) => void;
  min?: string;
  max?: string;
}

function addDays(iso: string, days: number) {
  const d = new Date(`${iso}T00:00:00`);
  d.setDate(d.getDate() + days);
  return d.toISOString().slice(0, 10);
}

export function DateSelector({ value, onChange, min, max }: Props) {
  const today = new Date().toISOString().slice(0, 10);
  return (
    <label className="field">
      <span>Data</span>
      <input
        type="date"
        value={value}
        min={min ?? today}
        max={max ?? addDays(today, 180)}
        onChange={(e) => onChange(e.target.value)}
        required
      />
    </label>
  );
}
